define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext) {
    "use strict";
    var E911Report = /** @class */ (function () {
        function E911Report() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,InternalReports.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
        }
        E911Report.prototype.init = function () {
            var self = this;
            $("#page-title").text("E911 Report");
            tools.ajaxGet({
                url: "/Reports/GetE911ReportLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookups = data.Data.lookupLists;
                        self.initGrid(self.lookups.GridStructures.E911ReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        E911Report.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblE911ReportKendo";
            var columns = gridStructure.columns;
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetE911Data",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "AccountNumber", dir: "asc" }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#commissionreport-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "E911Details",
                    title: "E911 Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
        };
        E911Report.prototype.clearFilter = function () {
            var self = this;
        };
        E911Report.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return E911Report;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/E911Report")) {
            log.log("Initialize E911Report list");
            $(function () {
                (new E911Report()).init();
            });
        }
    }, 0);
    return E911Report;
});
//# sourceMappingURL=e911Report.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/e911Report.js
// module id = 258
// module chunks = 2